import { FeatureFlag } from '../constants';

const isDisabled = (value?: string) => value === FeatureFlag.Value.OFF;
const isDisabledOrControl = (value?: string) =>
  isDisabled(value) || value === FeatureFlag.Value.CONTROL;
const isEnabled = (value?: string) => value === FeatureFlag.Value.ON;

export { isDisabled, isDisabledOrControl, isEnabled };
